module.exports = __webpack_public_path__ + "static/media/26-10.6264c7bd.mp3";